import { useContext, createContext } from 'react';
import { useQueue } from '../../hooks/useQueue.js';
import { createImmutableQueue } from '../../utils/queue.js';
import { jsx } from 'react/jsx-runtime';

const NotificationQueueContext = /*#__PURE__*/createContext(null);
function useNotificationQueue() {
  const queue = useContext(NotificationQueueContext);
  if (!queue) {
    throw new Error('Missing <NotificationProvider>');
  }
  return queue;
}
function NotificationProvider(_ref) {
  let {
    children
  } = _ref;
  const queue = useQueue(createImmutableQueue());
  return /*#__PURE__*/jsx(NotificationQueueContext.Provider, {
    value: queue,
    children: children
  });
}

export { NotificationProvider, useNotificationQueue };
